import { render } from "./SubscriptionsView.vue?vue&type=template&id=c85c2520&scoped=true"
import script from "./SubscriptionsView.vue?vue&type=script&lang=js"
export * from "./SubscriptionsView.vue?vue&type=script&lang=js"

import "./SubscriptionsView.vue?vue&type=style&index=0&id=c85c2520&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c85c2520"]])

export default __exports__